<div class="qr-container" #qrCanvas>
  <div class="qr-code-card">
    <!-- Header -->
    <div class="qr-code-header">
      rhyno.gg/<br>{{ atName }}
    </div>
    
    <!-- QR Code -->
    <div class="qr-code-wrapper">
      <div class="qr-code-canvas-wrapper"></div>
    </div>
    
    <!-- Footer com mensagens rotativas -->
    <div class="qr-code-footer">
      <div class="rotating-text-container">
        <div class="rotating-text" [class.active]="currentMessageIndex === 0">
          Conheça a Rhyno!
        </div>
        <div class="rotating-text" [class.active]="currentMessageIndex === 1">
          Envie mensagem na live!
        </div>
        <div class="rotating-text" [class.active]="currentMessageIndex === 2">
          Compre produtos personalizados!
        </div>
      </div>
    </div>
  </div>
</div>
